import React from 'react'
import { Col, Row, Container, Table } from "react-bootstrap";
import BreadcrumbLayout from "../../component/Breadcrumb";
import { useTranslation } from "react-i18next";
import AboutSidebar from "./AboutSideBar";

export default function ExecutiveCommittee() {
  const { t } = useTranslation();
  const menuData =
    t("menu", {
      returnObjects: true,
    }) || {};
  return (
    <>
      <BreadcrumbLayout title="Executive Committee" />
      <Container fluid >
        <Row>
          {/* Sidebar */}
          <AboutSidebar menuData={menuData} />
          {/* Content Area */}
          <Col md={9} className="content order-md-last order-first">
            <Row>
              <Col xs={12} className="heading">
                <h3>{t("executivecommittee.title")}</h3>
              </Col>
              <Col xs={12} className='mb-1 mt-1'>
                <p style={{ textAlign: "justify" }} className='fw-b'>
                  {t("executivecommittee.paragraph")}
                </p>
                {/* <div className='ml-2 mr-2'>
                  <Table bordered striped hover className="officers-list mt-3">
                    <thead>
                      <tr>
                        <th>{t('executivecommittee.sn')}</th>
                        <th>{t('executivecommittee.department')}</th>
                        <th>{t('executivecommittee.designation')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {t('executivecommittee.data', { returnObjects: true }).map(item => (
                        <tr key={item.srn}>
                          <td>{item.srn}</td>
                          <td>{item.Department}</td>
                          <td>{item.Designation}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div> */}

                <div className="ml-2 mr-2 responsive-table">
                  {/* <Table bordered striped hover className="officers-list mt-3">
                    <thead>
                      <tr>
                        <th>{t('executivecommittee.sn')}</th>
                        <th>{t('executivecommittee.department')}</th>
                        <th>{t('executivecommittee.designation')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {t('executivecommittee.data', { returnObjects: true }).map(item => (
                        <tr key={item.srn}>
                          <td style={{textAlign:"center"}}>{item.srn}.</td>
                          <td style={{textAlign:"justify"}}>{item.Department}</td>
                          <td style={{textAlign:"center"}}>{item.Designation}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table> */}

                  <Table
                    bordered
                    hover
                    responsive
                    className="text-center align-middle"
                  >
                    <thead className="table-primary">
                      <tr>

                        <th style={{ width: "10%" }}>{t('executivecommittee.sn')}</th>
                        <th >{t('executivecommittee.department')}</th>
                        <th style={{ width: "15%" }}>{t('executivecommittee.designation')}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {t('executivecommittee.data', { returnObjects: true }).map(item => (
                        <tr key={item.srn}>
                          <td>{item.srn}.</td>
                          <td className="text-start">{item.Department}</td>

                          <td>
                            <span className="badge bg-success px-3 py-2">
                              {item.Designation}
                            </span>
                          </td>
                        </tr>
                      ))}

                    </tbody>
                  </Table>
                </div>



              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}
